import defaultSettings from '../settings.json';
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    name?: string;
    avatar?: string;
    avatarUrl?: string;
    id?: string;
    accountId?: string;
    phone?: string;
    phoneNumber?: string;
    username?: string;
    nickname?: string;
    email?: string;
    registrationTime?: string;
    createdAt?: string;
    job?: string;
    organization?: string;
    location?: string;
    permissions?: Record<string, string[]>;
  };
  userLoading?: boolean;
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {},
  },
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings': {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }

    // 专门处理权限更新
    case 'update-permissions': {
      const { permissions } = action.payload;

      if (!permissions) return state;

      console.log('Store: 更新权限', permissions);

      // 确保userInfo存在
      const currentUserInfo = state.userInfo || {};

      return {
        ...state,
        userInfo: {
          ...currentUserInfo,
          permissions,
        },
      };
    }

    case 'update-userInfo': {
      const { userInfo = {}, userLoading } = action.payload;

      console.log('Store: 更新前的userInfo:', state.userInfo);
      console.log('Store: 更新操作的userInfo:', userInfo);

      // 确保当前userInfo存在
      const currentUserInfo = state.userInfo || {};

      // 创建合并后的用户信息
      const newUserInfo = {
        ...currentUserInfo, // 保留现有属性
        ...userInfo, // 应用新的用户信息

        // 特别处理头像相关字段，确保一致性
        avatar: userInfo.avatar || currentUserInfo.avatar,
        avatarUrl: userInfo.avatarUrl || currentUserInfo.avatarUrl,

        // 如果有新的permissions则使用，否则保留旧的
        permissions: userInfo.permissions || currentUserInfo.permissions || {},
      };

      console.log('Store: 合并后的userInfo:', newUserInfo);

      return {
        ...state,
        userLoading:
          userLoading !== undefined ? userLoading : state.userLoading,
        userInfo: newUserInfo,
      };
    }
    default:
      return state;
  }
}
